<template>
	<v-layout wrap :class="isSync ? 'journal-detail-sync' : 'journal-detail'">
		<div class="content-header-mobile">
			<div class="blue-text">
				Debe: <br>
				{{ debit | formatAmount }}
			</div>
			<div class="red-text">
				Haber: <br>
				{{ credit | formatAmount }}
			</div>
			<div class="background-balance">
				Saldo: <br>
				{{ balance | formatAmount }}
			</div>
		</div>
		<v-flex xs12 mb-2 class="wrapper-detail" v-if="open">
			<div class="layout justify-center content-open">
				<span>Detalle de Asiento - Código: {{ rowSelected.code }}</span>
				<div class="ml-3 show-desktop">
					<button
						@click="toggleBtn"
						:disabled="Object.keys(rowSelected).length === 0">
						<v-icon color="success" v-if="open">arrow_drop_up</v-icon>
						<v-icon color="success" v-else>arrow_drop_down</v-icon>
					</button>
				</div>
			</div>
			<div class="pa-3" v-if="open">
				<!-- Cabecera de los detalles del asiento -->
				<journal-detail-table
					:row-selected="rowSelected"
					:row-detail="rowDetail"
					@change-date="$emit('change-date', $event)"
				/>
			</div>
		</v-flex>
		<v-layout wrap v-if="openDetailSeat">
			<v-flex xs12 class="title-heading pt-1">
				Detalles
			</v-flex>
			<v-flex xs12 class="body-seat-form">
				<v-layout row wrap align-start>
					<v-flex xs8>
						<v-layout row wrap align-end>
							<v-flex xs6 pr-2>
								<v-select
									:items="accounts"
									item-text="fullName"
									item-value="id"
									solo
									autocomplete
									hide-details
									class="filter-select shadow-inset select-autocomplete-create"
									v-model="modelDetail.accountingAccountId"
									return-object
									@input="setData">
								</v-select>
							</v-flex>
							<v-flex xs6>
								<app-input-text
									disabled
									readonly
									:text="accountingAccount.name"/>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs4 pl-2>
						<app-input-text
							model="reference"
							placeholder="Referencia"
							:tabindex="modules.length === 0 || modules.length === 1 ? 4 : 5"
							:text="modelDetail.reference"
							@input="$emit('set-model-data', $event)"
						></app-input-text>
					</v-flex>
					<v-flex xs4 pr-2>
						<app-input-text
							model="concept"
							placeholder="Concepto"
							:tabindex="modules.length === 0 || modules.length === 1 ? 5 : 6"
							:text="modelDetail.concept"
							@input="$emit('set-model-data', $event)"
						></app-input-text>
					</v-flex>
					<v-flex xs4>
						<autocomplete-component
							append-icon="expand_more"
							http-code="$http"
							:item="modelDetail.costCenterId"
							item-text="name"
							item-value="id"
							:items="costCenters"
							model="costCenterId"
							placeholder-value="Centro de costos"
							prop="name"
							autocomplete
							prop-search="name"
							:disabled="validCostCenter"
							:show-clear="true"
							:resource-url="`cost-center/${params.subsidiaryId}/subsidiary`"
							return-object
							select-create
							:tabindex="modules.length === 0 || modules.length === 1 ? 6 : 7"
							@return-data="setCostCenter"
						></autocomplete-component>
					</v-flex>
					<v-flex xs3 pl-2>
						<app-input-text
							model="amount"
							placeholder="Importe"
							:tabindex="modules.length === 0 || modules.length === 1 ? 7 : 8"
							:text="modelDetail.amount"
							tooltip-message="Ingresar el importe con signo negativo (-) para crear detalles de tipo HABER"
							tooltip-on-focused
							type="number"
							@input="$emit('set-model-data', $event)"
						></app-input-text>
						<span
							v-if="Number(modelDetail.amount) !== 0"
							:class="`${modelDetail.amount < 0 ? 'error' : 'secondary'}--text caption`">
							Detalle de tipo {{ typeDetail }}
						</span>
					</v-flex>
					<v-flex xs1 text-xs-center>
						<app-tooltip-button
							class="no-movil"
							icon="add_circle_outline"
							:text="validFields 
								? 'Completar todos los campos' 
								: validInsertCostCenter 
									? 'Debe escoger un centro de costo' 
									: 'Agregar'"
							color="#33cfc7"
							:disabled="validFields || validInsertCostCenter"
							:tabindex="modules.length === 0 || modules.length === 1 ? 8 : 9"
							@click-icon="$emit('add-detail')"
						></app-tooltip-button>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-flex xs12>
			<journal-detail-list
				:flag-edit-inline="flagEditInline"
				:accounts="accounts"
				:code-journal="codeJournal"
				:cost-centers="costCenters"
				:edit-detail-inline="editDetailInline"
				:rows="details"
				:flagDisabledAddSeat="flagDisabledAddSeat"
				:created-add="createdAdd"
				:toDeclare="toDeclare"
				:subsidiary-id="subsidiaryId"
				:settings="settings"
				@columns-Visible="$emit('columns-Visible')"
				@add-icon="$emit('add-icon', $event)"
				@edit-detail-inline="$emit('edit-detail-inline', $event)"
				@get-data="$emit('get-data', $event)"
				@on-search="$emit('on-search', $event)"
				@on-click="$emit('on-click', $event)"
				@click-icon="$emit('click-icon', $event)"
				@detail-seat="$emit('detail-seat', $event)"
				@create-action="$emit('create-action', $event)"
				@add-detail="$emit('add-detail-seat')"
			/>
		</v-flex>
		<v-flex xs12>
			<v-layout row wrap justify-center align-center>
				<v-flex xs4 v-if="showSeatForm">
					<v-layout row wrap>
						<v-flex xs6 pa-1>
							<button
								class="btn-seat btn-save"
								:disabled="disabledFormSave"
								type="button"
								@click="$emit('save-all')"
							>
								Guardar
							</button>
						</v-flex>
						<v-flex xs6 pa-1>
							<button
								class="btn-seat btn-clean"
								:disabled="disabledFormClean"
								type="button"
								@click="$emit('clean-all')"
							>
								Borrar
							</button>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs4 mb-2 v-if="editDetailInline || rowSelected.clone === 1">
					<v-layout row wrap>
						<v-flex xs6 pa-1>
							<v-tooltip top>
								<button
									slot="activator"
									class="btn-seat btn-save"
									:disabled="isLoading || squareAmounts || validButton"
									type="button"
									@click="$emit('save-all-details')"
								>
									Guardar
								</button>
								<span v-if="squareAmounts">Debe cuadrar el asiento para guardar</span>
								<span v-else>Guardar</span>
							</v-tooltip>
						</v-flex>
						<v-flex xs6 pa-1>
							<button
								class="btn-seat btn-clean"
								:disabled="disabledFormClean"
								type="button"
								@click="$emit('clean-all')"
							>
								Cancelar
							</button>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex pt-1 :class="showSeatForm ? 'xs8' : 'xs12'" v-if="open">
					<journal-detail-balance
						:balance="balance"
						:credit="credit"
						:debit="debit"
						:to-declare="toDeclare"
						:not-declare="notDeclare"
					/>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>

<script>
	import appDateMask from '@/components/shared/app-date-mask';
	import appInputText from '@/components/autocomplete/app-input-text';
	import autocompleteComponent from '@/components/autocomplete/autocomplete-component';
	import journalDetailBalance from '@/components/journal/journal-detail-balance';
	import journalDetailList from '@/components/journal/journal-detail-list';
	import appTooltipButton from '@/components/shared/app-tooltip-button';
	import journalDetailTable from '@/components/journal/journal-detail-table';

	function created() {
		this.$emit('columns-Visible');
	}
	function toggleBtn() {
		this.open = !this.open;
	}

	function rowSelected(value) {
		this.open = Object.keys(value).length;
	}

	function setData(value) {
		this.$emit('set-data-account', value);
	}

	function setCostCenter(value) {
		this.$emit('set-cost-center', value);
	}

	function typeDetail() {
		return this.modelDetail.amount < 0 ? 'HABER' : 'DEBE';
	}

	function validFields() {
		return !this.modelDetail.account || !this.modelDetail.accountingAccountId
		|| !this.modelDetail.amount	|| !this.modelDetail.concept
		|| !this.modelDetail.reference;
	}

	function validCostCenter() {
		let valid = false;
		if (this.modelDetail.account !== null) {
			const firstDigit = this.modelDetail.account.charAt(0);
			valid = (Number(firstDigit) < 4 && Number(firstDigit) > 8);
		}
		if (valid) {
			this.$emit('set-cost-center', {});
		}
		return valid;
	}
	function validInsertCostCenter() {
		let valid = false;
		if (this.settings.autoCenterCost) {
			const firstDigit = this.modelDetail.account.charAt(0);
			if ((Number(firstDigit) >= 4 && Number(firstDigit <= 8)) && !this.modelDetail.costCenterId) {
				valid = true;
			}
		}
		return valid;
	}

	function data() {
		return {
			open: false,
		};
	}

	export default {
		name: 'journail-detail',
		data,
		created,
		components: {
			appDateMask,
			appTooltipButton,
			appInputText,
			autocompleteComponent,
			journalDetailBalance,
			journalDetailList,
			journalDetailTable,
		},
		methods: {
			toggleBtn,
			setData,
			setCostCenter,
		},
		computed: {
			typeDetail,
			validFields,
			validCostCenter,
			validInsertCostCenter,
		},
		props: {
			accounts: {
				default: () => [],
				type: Array,
			},
			flagEditInline: {
				default: false,
				type: Boolean,
			},
			balance: Number,
			credit: Number,
			costCenters: {
				default: () => [],
				type: Array,
			},
			debit: Number,
			debitTotal: Number,
			details: {
				default: () => [],
				type: Array,
			},
			disabledFormClean: {
				default: false,
				type: Boolean,
			},
			disabledFormSave: {
				default: false,
				type: Boolean,
			},
			editDetailInline: {
				default: false,
				type: Boolean,
			},
			toDeclare: {
				type: Boolean,
				default: false,
			},
			notDeclare: {
				type: Boolean,
				default: false,
			},
			openDetailSeat: {
				type: Boolean,
				default: false,
			},
			codeJournal: String,
			rowSelected: {
				default: () => {},
				type: Object,
			},
			rowDetail: {
				default: () => {},
				type: Object,
			},
			showSeatForm: {
				default: false,
				type: Boolean,
			},
			subsidiaryId: [Number, String],
			accountingAccount: {
				default: () => {},
				type: Object,
			},
			modules: {
				default: () => [],
				type: Array,
			},
			modelDetail: {
				default: () => {},
				type: Object,
			},
			createdAdd: {
				type: Boolean,
				default: true,
			},
			flagDisabledAddSeat: {
				type: Boolean,
				default: true,
			},
			settings: {
				type: Object,
				default: () => {},
			},
			flagValid: {
				type: Boolean,
				default: false,
			},
			isLoading: {
				type: Boolean,
				default: false,
			},
			squareAmounts: {
				type: Boolean,
				default: false,
			},
			validButton: {
				default: false,
				type: Boolean,
			},
			isSync: {
				default: false,
				type: Boolean,
			},
		},
		watch: {
			rowSelected,
		},
	};
</script>

<style lang="scss" scoped>
.journal-detail {
	float: left;
	width: 40%;
	position: fixed;
	top: 135px;
	right: 20px;
	border-radius: 10px;
	border: PowderBlue 5px solid;
	height: calc(100vh - 150px);
}
.journal-detail-sync {
	float: left;
	width: 100%;
	// position: relative;
	// top: 170px;
	// right: 20px;
	// border-radius: 10px;
	// border: PowderBlue 5px solid;
}
.content-header-mobile {
	background-color: #eceff1;
	display: flex;
	justify-content: space-between;
	width: 100%;
}

.blue-text {
	color: #006edb;
	font-family: map-get($fonts, AvenirDemi);
	font-size: 12px;
	padding-left: 19px;
}

.red-text {
	color: #ff0000;
	font-family: map-get($fonts, AvenirDemi);
	font-size: 12px;
}

.background-balance {
	background-color: #a9bac2;
	color: white;
	font-family: map-get($fonts, AvenirBold);
	font-size: 12px;
	padding-top: 6px;
	text-align: center;
	width: 102px;
}

.content-header-mobile {
	display: none;

	@media (max-width: 768px) {
		display: flex;
	}
}

.content-open {
	background-color: #e0e5e8;
	font-weight: 700;
	padding: 5px 0;
}

.wrapper-detail {
	@media (max-width: 768px) {
		display: none;
	}
}

.btn-seat {
	color: white;
	border-radius: 10px;
    font-family: 'AvenirRegular';
    font-size: 14px;
	padding: 5px 15px;

	&[disabled] {
		opacity: 0.5;
	}

	&.btn-save {
		background-color: color(secondary);
	}

	&.btn-clean {
		background-color: color(error);
	}
}

.title-heading {
	background-color: #e0e5e8;
	color: color(black);
	font-family: font(AvenirBold);
	font-size: size(medium);
	height: 25px;
	text-align: center;
}

.show-desktop {
	@media (min-width: 1024px) {
		display: none;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/journal/journal-detail.vue